<script xmlns="http://www.w3.org/1999/html">
  import { location } from 'svelte-spa-router'

  $: isHome = $location === '/'
  $: postLocation = $location.split('/').length > 1 ? $location.substr($location.lastIndexOf('/')) : ''

  $: steps = $location.split('/').length > 1 ? $location.split('/').slice(0, -1) : ''


</script>

<div class="bg-white uppercase text-gray-600 font-light px-4 pt-2 pb-2 border-t">

  <span>SUPPORT /</span>
  <a href="/#"><span class={'hover:underline ' + (isHome ? 'text-red-500' : '')}>MYFLEXLINK </span></a>

  {#if !isHome}
    {#each steps as step, i}
      <a href={'/#' + $location.substr(0,$location.indexOf(step)+ step.length)}>
        <span class="hover:underline">{step}</span>
      </a>
      <span>{' / '}</span>
    {/each}


    <span class="text-red-500">{postLocation.replace('/', '')}</span>
  {/if}
</div>
